import React, { memo } from 'react';
import Image from 'next/image';
import styles from './styles.module.scss';
import { TeamMemeberProps } from './TeamMember.types';

const TeamMemberCard = memo<TeamMemeberProps>(
  ({ name, detail, title, imageFile, linkedInUrl }) => (
    <a href={linkedInUrl} className={styles.card} target="_blank" rel="noreferrer">
      <Image src={imageFile} alt={name} width={160} height={160} priority />
      <div className={styles.name}>{name}</div>
      <div className={styles.detail}>{detail}</div>
      <div className={styles.title}>{title}</div>
    </a>
  ),
);

export default TeamMemberCard;
